import { useEffect, useRef } from 'react'

/** Якорь калькулятора на странице торговли — на него ведёт ссылка с главной. */
export const CALCULATOR_ANCHOR = 'robot-calculator'

/** Инструмент из ссылки с главной (?symbol=id), если он есть среди доступных. */
export const symbolFromUrl = (ids: number[]) => {
    const id = Number(new URLSearchParams(window.location.search).get('symbol'))
    return ids.includes(id) ? id : undefined
}

/** Пришли по ссылке #robot-calculator — прокрутить к калькулятору, когда он отрисован. */
export const useScrollToCalculator = (ready: boolean) => {
    const done = useRef(false)
    useEffect(() => {
        if (
            !ready ||
            done.current ||
            window.location.hash !== `#${CALCULATOR_ANCHOR}`
        )
            return
        done.current = true
        setTimeout(
            () =>
                document
                    .getElementById(CALCULATOR_ANCHOR)
                    ?.scrollIntoView({ behavior: 'smooth', block: 'start' }),
            300
        )
    }, [ready])
}
